import * as Sentry from "@sentry/react";
import i18n from "i18next";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import "tippy.js/dist/tippy.css";

import App from "./App";
import "./i18n";
import "./index.scss";
import { store } from "./store/store";

const persistor = persistStore(store);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

if (process.env.REACT_APP_YBUG) {
  (function () {
    const lang = String(localStorage.getItem("lang") || i18n.language || "en")
      .split('"')
      .join("");

    // @ts-ignore
    window.ybug_settings = {
      id: process.env.REACT_APP_YBUG,
      widget_position: lang === "ar" ? "left" : "right",
      launcher_position: lang === "ar" ? "bottom-left" : "bottom-right", // change to bottom-left, right-middle, left-middle or top-middle
    };
    const ybug = document.createElement("script");
    ybug.type = "text/javascript";
    ybug.async = true;
    // @ts-ignore
    ybug.src =
      // @ts-ignore
      "https://widget.ybug.io/button/" + window.ybug_settings.id + ".js";
    const s = document.getElementsByTagName("script")[0];
    s && s.parentNode && s.parentNode.insertBefore(ybug, s);
  })();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
